/**
 * PORTAL build flag (web game portals: CrazyGames / Poki / YouTube Playables-style). `pnpm --filter @hf/client
 * build:portal` sets VITE_HF_PORTAL=1: a vs-CPU + local 2-player (same device), fully offline static bundle with NO online play,
 * NO sign-in, NO coins / store / purchases and NO analytics. Vite replaces the env read at build time, so the regular
 * web build (and the native apps, which never import apps/client) keep every feature and drop the portal branches.
 */
export const PORTAL: boolean =
  (import.meta as unknown as { env?: Record<string, string | undefined> }).env?.['VITE_HF_PORTAL'] === '1';

/** The asset manifest URL: relative in the portal bundle (served from any subfolder), root-relative otherwise. */
export const MANIFEST_URL = PORTAL ? 'assets/manifest.json' : '/assets/manifest.json';

if (PORTAL && typeof document !== 'undefined') document.documentElement.classList.add('hf-portal');
